import React from 'react';

import { createAppState } from 'utils/createAppState';
import { AppStateContext } from 'contexts/appStateContext';
import { AppDispatcherContext } from 'contexts/appDispatcherContext';
import { reduceToNextAppState } from 'reducers/appStateReducers';

export const AppStoreProvider: React.FC = ({ children }) => {
  const [state, dispatch] = React.useReducer(
    reduceToNextAppState,
    null,
    createAppState
  );

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatcherContext.Provider value={dispatch}>
        {children}
      </AppDispatcherContext.Provider>
    </AppStateContext.Provider>
  );
};
